<template>
  <button class="redirect-one-drive-button" @click="openLink">{{ buttonText }}</button>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({})
export default class RedirectOndeDriveButton extends Vue {  
  @Prop({ type: String, required: true }) readonly linkUrl!: string
  @Prop({ type: String, default: 'Acessar arquivos' }) readonly buttonText!: string

  openLink(): void {
    window.open(this.linkUrl, '_blank')
  }
}
</script>

<style scoped>
.redirect-one-drive-button {
  width: 209px;
  height: 40.62px;

  padding: 8.81px 13.21px 8.81px 13.21px;
  border-radius: 8.81px;
  border: none;
  cursor: pointer;

  color: #fff;
  background: linear-gradient(
    90deg,
    #0079fd -37.91%,
    #2d51fb 20.11%,
    #5a29fa 78.13%,
    #8800f8 137.91%
  );
}
</style>
